import mapboxgl from "mapbox-gl";

export function geolocateControl(
  statefulMap: mapboxgl.Map,
): Promise<{ longitude: number; latitude: number } | null> {
  return new Promise((resolve, reject) => {
    const geolocateControl = new mapboxgl.GeolocateControl({
      positionOptions: {
        enableHighAccuracy: true,
        timeout: 15000, // Increased to 15 seconds
      },
      trackUserLocation: true,
      showUserLocation: true,
      showUserHeading: true,
    });

    statefulMap.addControl(geolocateControl);

    setTimeout(() => {
      geolocateControl.trigger();
    }, 100);

    geolocateControl.on("geolocate", (e) => {
      resolve(e.coords);
    });

    geolocateControl.on("error", (err) => {
      if (err.code === 3) {
        console.log(
          "Geolocation took too long and timed out. Please try again.",
        );
      } else {
        console.log("Error occurred during geolocation:", err);
      }
      reject(err);
    });
  });
}
